module.exports = __webpack_public_path__ + "static/media/unionIcon.1820b396.svg";